module.exports = __webpack_public_path__ + "static/media/wus_logo.fb2acd80.svg";